import { useStaticQuery, graphql } from "gatsby"

const useRecipeQuery = () => {
  const { allDatoCmsRecipe } = useStaticQuery(graphql`
    query Recipes {
      allDatoCmsRecipe(filter: {hideForLocale: {ne: true}}, sort: {position: DESC}) {
        nodes {
          id
          originalId
          title
          brand
          excerpt
          tags {
            title
          }
          slug
          permalink
          header
          featureImage {
            ...InternalAssetProps
          }
          thumbnail {
            ...InternalAssetProps
          }
          relatedProducts {
            ... on DatoCmsEdlynProduct {
              originalId
            }
            ... on DatoCmsBoneProduct {
              originalId
            }
            ... on DatoCmsWoodsProduct {
              originalId
            }
            ... on DatoCmsGreenwheatProduct {
              originalId
            }
          }
        }
      }
    }
  `)

  return allDatoCmsRecipe.nodes
}

export default useRecipeQuery